// import { createConsumer } from '@rails/actioncable';
// import SubscriptionExchange from 'graphql-ruby-client/subscriptions/SubscriptionExchange';
import api /* { actioncablePath } */ from '../api/Schema/Api';

// src/graphql/client.js
import {
  Provider,
  Client,
  cacheExchange,
  fetchExchange,
  /* subscriptionExchange */
} from 'urql';

export default function GraphQlProvider({ children }) {
  const url = `${new URL('/graphql', api.baseUrl)}`;
  const token = api.getJWT();

  // const cableUrl = new URL(actioncablePath, api.baseUrl);
  // cableUrl.search = new URLSearchParams({ token });
  // const actionCable = createConsumer(cableUrl);
  // const forwardToActionCable = SubscriptionExchange.create({
  //   consumer: actionCable,
  //   channelName: 'GraphqlChannel',
  // });
  const client = new Client({
    url,
    exchanges: [
      cacheExchange,
      fetchExchange,
      //  subscriptionExchange({
      //    forwardSubscription: forwardToActionCable,
      //  }),
    ],
    fetchOptions: () => {
      return {
        headers: {
          // matches your Rails SessionHelpers logic
          authorization: `Bearer ${token}`,
        },
      };
    },
  });
  return <Provider value={client}>{children}</Provider>;
}
